module.exports = "/assets/data/915f4306a9b140cba69d409c1f362103-B93.data.json";